import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { dashboardService } from "services/dashboard.api";
import { setSalesTrend } from "store/dashboardSlice";
import { setDealersOnboardingTrend } from "store/dashboardSlice";
import { selectActiveCompaign } from "store/dashboardSlice";
import { setSearchTerm } from "store/dashboardSlice";
import { selectSearchTerm } from "store/dashboardSlice";
import { setActiveCompaign } from "store/dashboardSlice";
import { setDealersPerformance } from "store/dashboardSlice";
import { selectDealersOnboardingTrend } from "store/dashboardSlice";
import { selectSalseTrend } from "store/dashboardSlice";
import { selectDealersPerformance } from "store/dashboardSlice";
import { selectCardCount } from "store/dashboardSlice";
import { setCardCount } from "store/dashboardSlice";

const useDashboard = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const cardCount = useSelector(selectCardCount);
  const salseTrend = useSelector(selectSalseTrend);
  const dealersPerformance = useSelector(selectDealersPerformance);
  const dealersOnboardingTrend = useSelector(selectDealersOnboardingTrend);
  const activeCampaign = useSelector(selectActiveCompaign);
  const searchTerm = useSelector(selectSearchTerm);
  const [error, setError] = useState(null);

  const getCardCounts = async () => {
    setLoading(true);
    try {
      const response = await dashboardService.fetchCardCounts();
      if (response.success) {
        dispatch(setCardCount(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getSalesTrend = async (payload) => {
    setLoading(true);
    try {
      const response = await dashboardService.fetchDashboardSalesTrend(payload);
      if (response.success) {
        dispatch(setSalesTrend(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getDealersPerformance = async (payload) => {
    setLoading(true);
    try {
      const response = await dashboardService.fetchDashboardDealersPerformance(payload);
      if (response.success) {
        dispatch(setDealersPerformance(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getDealersOnboardingTrend = async (payload) => {
    setLoading(true);
    try {
      const response = await dashboardService.fetchDashboardDealersOnboardingTrend(payload);
      if (response.success) {
        dispatch(setDealersOnboardingTrend(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const getActiveCampaign = async (payload) => {
    setLoading(true);
    try {
      const response = await dashboardService.fetchDashboardActiveCampaign(payload);
      if (response.success) {
        dispatch(setActiveCompaign(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const setSearchValue = (value) => {
    dispatch(setSearchTerm(value));
  };

  return {
    getCardCounts,
    getActiveCampaign,
    activeCampaign,
    getDealersPerformance,
    getDealersOnboardingTrend,
    salseTrend,
    dealersPerformance,
    dealersOnboardingTrend,
    getSalesTrend,
    searchTerm,
    setSearchValue,
    cardCount,
    loading,
    error,
  };
};

export default useDashboard;
